var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourglassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2503_15550)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 54,
    r: 46,
    fill: "#8D68F1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9993 54.0003C59.9993 51.3323 64.3273 49.5083 66.666 46.0003C69.3327 42.0003 69.3327 32.667 69.3327 32.667H42.666C42.666 32.667 42.666 42.0003 45.3327 46.0003C47.6713 49.5083 51.9993 51.3323 51.9993 54.0003C51.9993 56.6683 47.6713 58.4923 45.3327 62.0003C42.666 66.0003 42.666 75.3337 42.666 75.3337H69.3327C69.3327 75.3337 69.3327 66.0003 66.666 62.0003C64.3273 58.4923 59.9993 56.6683 59.9993 54.0003Z",
    fill: "#FFE8B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0007 32.667H45.334C45.334 32.667 45.334 38.0003 46.6673 42.0003C48.406 47.2163 54.6673 48.6657 54.6673 54.0003C54.6673 59.335 54.6673 71.3337 56.0007 71.3337C57.334 71.3337 57.334 59.3337 57.334 54.0003C57.334 48.667 63.5967 47.2163 65.334 42.0003C66.6673 38.0003 66.6673 32.667 66.6673 32.667H56.0007Z",
    fill: "#FFAC33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72 75.3333C72 76.8053 70.8053 78 69.3333 78H42.6667C41.1947 78 40 76.8053 40 75.3333C40 73.8613 41.1947 72.6667 42.6667 72.6667H69.3333C70.8053 72.6667 72 73.8613 72 75.3333ZM72 32.6667C72 34.1387 70.8053 35.3333 69.3333 35.3333H42.6667C41.1947 35.3333 40 34.1387 40 32.6667C40 31.1947 41.1947 30 42.6667 30H69.3333C70.8053 30 72 31.1947 72 32.6667Z",
    fill: "#3B88C3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2503_15550",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2503_15550"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2503_15550"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2503_15550",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassIcon);
export default __webpack_public_path__ + "static/media/hourglass_icon.10e8b9038e6029580d78ee500041c2d4.svg";
export { ForwardRef as ReactComponent };